import React from 'react'
import {ParagraphText, Radio} from '@thryvlabs/maverick'

function OnboardingFeeRequired({
  onboardingFeeRequired,
  setOnboardingFeeRequired,
}) {
  const handleOnboardingFeeRequiredChange = ({target: {value}}) => {
    setOnboardingFeeRequired(prevState => ({...prevState, value}))
  }

  return (
    <div className="d-flex flex-column" style={{rowGap: '30px'}}>
      <div>
        <ParagraphText variant="reg" className="text-left">
          {'Do you want to add onboarding fee?'}
        </ParagraphText>
        <div className="d-flex gap-3">
          <Radio
            hasLabel
            id="onboardingFeeYes"
            name="onboardingFeeRequired"
            value="Yes"
            label="Yes"
            toggled={onboardingFeeRequired === 'Yes'}
            handleOnChange={handleOnboardingFeeRequiredChange}
          />
          <Radio
            hasLabel
            id="onboardingFeeNo"
            name="onboardingFeeRequired"
            value="No"
            label="No"
            toggled={onboardingFeeRequired === 'No'}
            handleOnChange={handleOnboardingFeeRequiredChange}
          />
        </div>
      </div>
    </div>
  )
}

export {OnboardingFeeRequired}
